import React from 'react'

export default function ScoreBoard({ game, className='' }) {
  return (
    <div className={ className + " turn-in-progress__score" }>
      <p>Score</p>
      <p className="turn-in-progress__clock">
        <span className="color-team-one">{ game.team_1.score }</span>
        <span>-</span>
        <span className="color-team-two">{ game.team_2.score}</span>
      </p>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/score-board.jsx
 **/